import { useEffect, useState } from 'react'

const useDynamicWindowWidthHook = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  const handleResize = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      // cleanup
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return {
    windowWidth,
  }
}

export default useDynamicWindowWidthHook
